import { Outlet } from 'react-router-dom';
import { NavigationRail } from './NavigationRail';
import { CharacterSummary } from './CharacterSummary';

/**
 * Layout principal: no permite scroll de página. Todo se reparte en paneles
 * con scroll interno contenido.
 *
 *  - Mobile (<md): nav como barra inferior fija, personaje oculto.
 *  - Tablet (md-lg): nav lateral icon-only, personaje oculto.
 *  - Desktop (xl+): nav lateral con labels, aside con resumen del personaje.
 */
export function MainLayout() {
  return (
    <div className="h-full w-full flex flex-col md:flex-row overflow-hidden">
      <NavigationRail />
      <main className="flex-1 min-h-0 min-w-0 relative overflow-hidden">
        <Outlet />
      </main>
      <aside className="hidden xl:flex flex-col shrink-0 w-72 border-l border-ash-800/60 bg-ash-950/60 backdrop-blur-sm min-h-0">
        <CharacterSummary />
      </aside>
    </div>
  );
}
